import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AboutUs from "@/pages/AboutUs";
import OurTeam from "@/pages/OurTeam";
import InternationalBoard from "@/pages/InternationalBoard";
import NationalProjectTeam from "@/pages/NationalProjectTeam";
import Partners from "@/pages/Partners";
import NewsArchive from "@/pages/NewsArchive";
import Activities from "@/pages/Activities";
import Mission from "@/pages/Mission";
import Events from "@/pages/Events";
import Treasures2026 from "@/pages/Treasures2026";
import EUToday from "@/pages/EUToday";
import EUHeritage from "@/pages/EUHeritage";
import EUCEE from "@/pages/EUCEE";
import RoadTo27 from "@/pages/RoadTo27";
import EUEuro from "@/pages/EUEuro";
import EULanguages from "@/pages/EULanguages";
import Contact from "@/pages/Contact";
import ArticleDetail from "@/pages/ArticleDetail";
import CountryDetail from "@/pages/CountryDetail";
import ActivityDetail from "@/pages/ActivityDetail";
import NPTApply from "@/pages/NPTApply";
import InBetweenSubmit from "@/pages/InBetweenSubmit";
import InBetweenRegolamento from "@/pages/InBetweenRegolamento";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import ScrollToTop from "@/components/site/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          {/* About Us */}
          <Route path="/about" element={<AboutUs />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/international-board" element={<InternationalBoard />} />
          <Route path="/national-project-team" element={<NationalProjectTeam />} />
          <Route path="/npt-apply" element={<NPTApply />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/news-archive" element={<NewsArchive />} />
          {/* Activities */}
          <Route path="/activities" element={<Activities />} />
          <Route path="/activities/:slug" element={<ActivityDetail />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/events" element={<Events />} />
          {/* Treasures */}
          <Route path="/treasures-2026" element={<Treasures2026 />} />
          {/* EU Today */}
          <Route path="/eu-today" element={<EUToday />} />
          <Route path="/eu-heritage" element={<EUHeritage />} />
          <Route path="/eu-cee" element={<EUCEE />} />
          <Route path="/road-to-27" element={<RoadTo27 />} />
          <Route path="/eu-euro" element={<EUEuro />} />
          <Route path="/eu-languages" element={<EULanguages />} />
          {/* Contact */}
          <Route path="/contact" element={<Contact />} />
          {/* Articles */}
          <Route path="/articles/:slug" element={<ArticleDetail />} />
          {/* InBetween photo contest submission */}
          <Route path="/inbetween/submit" element={<InBetweenSubmit />} />
          {/* InBetween regolamento — NOT in nav menu, only reachable from submit form */}
          <Route path="/inbetween/regolamento" element={<InBetweenRegolamento />} />
          {/* Countries */}
          <Route path="/country/:slug" element={<CountryDetail />} />
          {/* Legal */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
